<template>
  <MenuItem v-slot="{ active }">
    <div
      class="flex cursor-pointer gap-1 p-2 first:rounded-t-md last:rounded-b-md"
      :class="
        active ? activeVariantClassMap[variant] : variantClassMap[variant]
      "
    >
      <slot />
    </div>
  </MenuItem>
</template>

<script lang="ts" setup>
import { MenuItem } from '@headlessui/vue';

type ContextActionMenuVariant = 'neutral' | 'danger' | 'primary';

withDefaults(
  defineProps<{
    variant?: ContextActionMenuVariant;
  }>(),
  { variant: 'primary' },
);

const variantClassMap: Record<ContextActionMenuVariant, string> = {
  neutral: 'text-neutral-500 hover:bg-neutral-100',
  primary: 'text-primary-500 hover:bg-primary-100',
  danger: 'text-danger-500 hover:bg-danger-100',
};

const activeVariantClassMap: Record<ContextActionMenuVariant, string> = {
  neutral: 'text-neutral-500 bg-neutral-50',
  primary: 'text-primary-500 bg-primary-50',
  danger: 'text-danger-500 bg-danger-50',
};
</script>
